﻿import { msalInstance } from "../index";
import { silentRequest, b2cPolicies } from "./authConfig";

export const getGroup = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();
  let response;
  try {
    return activeAccount.idTokenClaims["groups"][0];
  } catch (e) {
    if (
      activeAccount.idTokenClaims["acr"] !=
      b2cPolicies.names.signUpSignIn.toLowerCase()
    ) {
      msalInstance.logoutRedirect();
    } else {
      response = await msalInstance.acquireTokenSilent({
        ...silentRequest,
        account: activeAccount,
      });
    }

    return response.idTokenClaims["groups"][0];
  }
};
